import {
  ActionStatusChip,
  ContainerPopper,
  FakeDropdownBox,
  GroupedStatus,
  IssueStatusChip,
  StatusMultipleSelector,
  useDataGridContext,
} from '@issuemanager/apps/client/components';

import { Stack, useEventCallback } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IssueGridFilterModel } from './types';

export function IssueGridStatusFilter(): React.JSX.Element {
  const context = useDataGridContext();
  const { t } = useTranslation();

  const issueStatusLabel = t('statusLabels.issue');
  const actionStatusLabel = t('statusLabels.action');

  const issueStatuses: IssueGridFilterModel['status'] =
    context.filterModel.status;
  const actionStatuses: IssueGridFilterModel['actionStatus'] =
    context.filterModel.actionStatus;

  const value: GroupedStatus[] = [
    ...(issueStatuses ?? []),
    ...(actionStatuses ?? []),
  ];

  const handleChange = useEventCallback((newValue: GroupedStatus[]) => {
    const filteredIssueStatuses = newValue.filter(
      (v) => v.group === issueStatusLabel,
    );
    const filteredActionStatuses = newValue.filter(
      (v) => v.group === actionStatusLabel,
    );
    context.setFilterModel((prevState) => ({
      ...prevState,
      status: filteredIssueStatuses,
      actionStatus: filteredActionStatuses,
    }));
  });

  return (
    <ContainerPopper
      renderTarget={(props) => (
        <FakeDropdownBox onClick={props.handleClick}>
          {value.length ? (
            <Stack direction='row' spacing={0.5}>
              {issueStatuses?.map(({ id, statusValue, isInitiatedValue }) => (
                <IssueStatusChip
                  key={id}
                  status={statusValue}
                  isInitiated={isInitiatedValue}
                />
              ))}
              {actionStatuses?.map((status) => (
                <ActionStatusChip key={status.id} status={status.value} />
              ))}
            </Stack>
          ) : null}
        </FakeDropdownBox>
      )}
      renderChildren={(props) => (
        <StatusMultipleSelector
          open
          value={value}
          onChange={handleChange}
          onClose={props.handleClose}
          TextFieldProps={{
            autoFocus: true,
          }}
        />
      )}
    />
  );
}
